'use client'

import eventBus from '@/app/eventBus'
import { emitSearchHotelsNowGAEvent } from '@/app/ga-event-helpers'
import { PS_EVENTS } from '@/app/ps-events'
import { Icons } from '@/app/components/ui/Icons'
import Title from '@/app/components/common/Title'
import Button from '@/app/components/common/Button'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { stripHtmlTags } from '@/app/utils'
import '@/app/styles/components/SearchBestDealsBannerWidget.css'

export default function SearchBestDealsBannerWidget() {
	const t = useTranslations('Main.searchBanner')

	const handleButtonClick = () => {
		emitSearchHotelsNowGAEvent()
		eventBus.publish(PS_EVENTS.HANDLE_SEARCH)
	}

	return (
		<section className="search-best-deals-banner">
			<div className="container search-best-deals-banner__container">
				<div className="search-best-deals-banner__wrapper">
					<picture className="search-best-deals-banner__background">
						<source
							media="(min-width: 768px)"
							srcSet="/images/search-banner-desktop.webp"
						/>
						<Image
							src="/images/search-banner-mobile.webp"
							alt={stripHtmlTags(t.raw('title'))}
							fill
							priority
							sizes="100vw"
							className="search-best-deals-banner__image"
						/>
					</picture>
					<div className="search-best-deals-banner__content">
						<Title
							level="4"
							className="search-best-deals-banner__title"
							testId="search-banner-title"
						>
							{t.rich('title', {
								light: (chunks) => (
									<span className="search-best-deals-banner__title-light">
										{chunks}
									</span>
								),
								priceBreak: (chunks) => (
									<span className="search-best-deals-banner__price-break">
										{chunks}
									</span>
								),
							})}
						</Title>
						<Button
							type="button"
							onClick={handleButtonClick}
							name={t('buttonText')}
							className="search-best-deals-banner__button"
						>
							<Icons.iconLens className="search-best-deals-banner__icon" />
							<span className="search-best-deals-banner__button-text">
								{t('buttonText')}
							</span>
						</Button>
					</div>
				</div>
			</div>
		</section>
	)
}
